import ParametersIcon from './ParametersIcon'
import TimetableIcon from './TimetableIcon'
import NewsletterIcon from './NewsletterIcon'

export default {
  ParametersIcon,
  TimetableIcon,
  NewsletterIcon,
}
